import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { BaseService } from '../shared/service/base.service';
import { AuthService } from '../shared/auth/auth.service';
import { Module } from '../shared/model/module.model';
import { Observable } from 'rxjs';
import { Brand } from '../brands-list/brands.model';
import { CategoryListModel } from '../category-list/category-list.model';
import { CategorySectionListModel } from '../category-list/category-section-list.model';
@Injectable()
export class EducationModulesService extends BaseService<Module> {

  constructor(_authService: AuthService,
    _http: Http) {
    super('/api/modules', _authService, _http);
  }

  getHomeModules(view: string,brandId?:string,categoryId?:string,companyId?): Observable<Module[]> {
    let params: URLSearchParams = new URLSearchParams();

    if (view !== undefined) {
      params.set('view', view);
    } else {
      params.set('view', 'Featured');
    }
     if (brandId !== undefined) {
      params.set('brandId', brandId);
    } else {
      params.set('brandId', '');
    }
     if (categoryId !== undefined) {
      params.set('categoryId', categoryId);
    } else {
      params.set('categoryId', '');
    }
    if (companyId !== undefined) {
      params.set('companyId', companyId);
    } else {
      params.set('companyId', '');
    }
    if(this._authService.getUserData() != null){
    console.log(this._authService.getUserData().breezeSessionString);
    if(this._authService.getUserData().breezeSessionString !== undefined){
      params.set('breezeSessionString',this._authService.getUserData().breezeSessionString);
    }else{
      params.set('breezeSessionString',this._authService.getBreezeSessionString());
    }
     console.log(this._authService.getUserData().iBreezeUserID);
     if(this._authService.getUserData().iBreezeUserID !== undefined){
      params.set('iBreezeUserID',this._authService.getUserData().iBreezeUserID);
    }else{
      params.set('iBreezeUserID','');
    }
  }
    return this._http.get(this._baseUrl + '/getHomeFeaturedModules', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json());
      //;
  }

  getBrandsList():Observable<Brand[]> {
      let params: URLSearchParams = new URLSearchParams();
    return this._http.get(this._baseUrl + '/getAllBrands', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;
  }
  getSelfBrandsList(brandID:string):Observable<Brand[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('brandID',brandID);
  return this._http.get(this._baseUrl + '/getAllBrands', {
    headers: this._authService.getAuthorizationHeaders(),
    search: params
  })
    .map((res: Response) => res.json())
    ;
}

  getCategoryList():Observable<CategoryListModel[]> {
      let params: URLSearchParams = new URLSearchParams();
    return this._http.get(this._baseUrl + '/getAllCategories', {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;
  }
  getCategorySectionList():Observable<CategorySectionListModel[]> {
    let params: URLSearchParams = new URLSearchParams();
  return this._http.get(this._baseUrl + '/getSectionCategories', {
    headers: this._authService.getAuthorizationHeaders(),
    search: params
  })
    .map((res: Response) => res.json())
    ;
}

}



// WEBPACK FOOTER //
// ./src/app/education-modules/education-modules.service.ts